import React from 'react';

function Footer() {
  return (
    <footer className="tc-footer-style2">
      <div className="container">
        <div className="foot-main-content">
          <div className="row">
            <div className="col-lg-4">
              <div className="foot-info">
                <h3 className="fsz-35 fw-500">
                  Space. Aesthetic. Life. Moments.
                  <span className="sub-font color-orange1 fst-italic">
                    Yourself
                  </span>
                </h3>
                <a
                  href="#"
                  className="butn borderd border rounded-pill hover-bg-black mt-40"
                >
                  <span>
                    <i className="me-2 fal fa-envelope" ></i><a href="#"> operations@artisanguildinfra.com</a>
                  </span>
                  
                </a>
                <a
                  href="#"
                  className="butn borderd border rounded-pill hover-bg-black mt-20">
                  <span>
                  <i className="me-2 fal fa-phone"  ></i><a href="tel:+91 87545 05413"> +91 87545 05413</a>
                  </span>
                </a>
              </div>
            </div>
            <div className="col-lg-3 offset-lg-1">
              <div className="links-group">
                <h5 className="sub-title fsz-24 fw-500 mb-30 mt-5 mt-lg-0">
                 Office
                </h5>
                <ul>
                  <li>
                    <a href="#"> 1st Main, Madurai Manavalan Nagar, Pooniammanmedu, Chennai, TN – 600110 </a>
                  </li>
                  <li>
                    <a href="#"> Karaparamba, Malikadavu Road, Kozhikode – 673010</a>
                  </li>
                  <li>
                    <a href="#"> <strong>Fabrication Unit:</strong> Kunnathur, Coimbatore, Tamil Nadu - 641110</a>
                  </li>
                  <li>
                    <a href="#"> operations@artisanguildinfra.com</a>
                  </li>
                  
                </ul>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="links-group">
                <h5 className="sub-title fsz-24 fw-500 mb-30 mt-5 mt-lg-0">
                  Company
                </h5>
                <ul>
                  <li>
                    <a href="/about"> About </a>
                  </li>
                  <li>
                    <a href="/services"> Services </a>
                  </li>
                  <li>
                    <a href="/portfolio"> Projects </a>
                  </li>
                  
                  <li>
                    <a href="/contact"> Contact </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2">
              <div className="links-group">
                <h5 className="sub-title fsz-24 fw-500 mb-30 mt-5 mt-lg-0">
                  Helps
                </h5>
                <ul>
                  <li>
                    <a href="#"> Terms & Conditions </a>
                  </li>
                  <li>
                    <a href="#"> Partner Policy </a>
                  </li>
                  <li>
                    <a href="#"> Affiliate Program </a>
                  </li>
                  <li>
                    <a href="#"> FAQs </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="foot">
          <div className="row align-items-center">
            <div className="col-lg-2">
              <a href="#" className="logo">
                <img src="/home2/assets/img/logo-1.png" alt="" />
              </a>
            </div>
            <div className="col-lg-3">
              <p className="copy">
                © 2025 Artisian Guild Infra. <br /> All Right Reserved
              </p>
            </div>
            <div className="col-lg-5">
              <div className="social-links">
                <a href="#">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href="#">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href="https://www.instagram.com/artisanguildinfra?igsh=c2FlYzFvY3lrZnRu">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="#">
                  <i className="fab fa-linkedin-in"></i>
                </a>
                <a href="#">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </div>
            <div className="col-lg-2">
              <a
                href="#"
                className="butn borderd border rounded-pill hover-bg-black"
                id="to_top"
              >
                <span>
                  Back to Top <i className="ms-2 fal fa-chevron-up"></i>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <img src="/home2/assets/img/foot_shap.svg" alt="" className="shap" />
    </footer>
  );
}

export default Footer;
